import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

interface ThemeState {
  themeId: string;
  isDarkMode: boolean;
  setThemeId: (themeId: string) => void;
  setDarkMode: (isDark: boolean) => void;
  toggleDarkMode: () => void;
}

export const useThemeStore = create<ThemeState>()(
  devtools(
    persist(
      (set, get) => ({
        themeId: "#000003", 
        isDarkMode: false,
        setThemeId: (themeId) => set({ themeId }, false, "setThemeId"),
        setDarkMode: (isDark) => set({ isDarkMode: isDark }, false, "setDarkMode"),
        toggleDarkMode: () => set({ isDarkMode: !get().isDarkMode }, false, "toggleDarkMode"),
      }),
      {
        name: "outlook-addin-theme-store",
        version: 1,
        storage: createJSONStorage(() => {
          if (typeof window !== "undefined") {
            return localStorage;
          }
          const noopStorage: Storage = {
            length: 0,
            clear: () => {},
            getItem: () => null,
            key: () => null,
            removeItem: () => {},
            setItem: () => {},
          };
          return noopStorage;
        }),
        partialize: (state) => ({
          themeId: state.themeId,
          isDarkMode: state.isDarkMode,
        }),
      }
    )
  )
);
